export default __webpack_public_path__ + "static/media/card_action_view.4b52b919.svg";